// play-video-correct component: versione semplificata e funzionante basata su /ologramma/app.js
const playVideoCorrectComponent = {
  schema: {
    video: {type: 'string'},
    autoplay: {type: 'boolean', default: false},
    ctaId: {type: 'string', default: 'cta'},
  },
  init() {
    const videoEl = document.querySelector(this.data.video)
    const {el} = this
    const prompt = document.getElementById(this.data.ctaId)
    let playing = false

    console.log('[ologramma] init play-video-correct (versione semplificata)', {
      selector: this.data.video,
      autoplay: this.data.autoplay,
      ctaId: this.data.ctaId,
      el,
      videoEl,
      prompt
    })

    if (!videoEl) {
      console.error(`[play-video-correct] Video element not found via selector: ${this.data.video}`)
      return
    }

    // Nascondi l'ologramma all'inizio
    el.setAttribute('visible', 'false')
    console.log('[ologramma] Entity hidden initially')

    if (this.data.autoplay) {
      videoEl.autoplay = true
      videoEl.muted = true
      videoEl.play()
      el.setAttribute('visible', 'true')
      console.log('[ologramma] Autoplay enabled, entity visible')
    } else if (prompt) {
      console.log('[ologramma] Waiting for CTA click')
      prompt.addEventListener('click', () => {
        if (!playing) {
          playing = true
          console.log('[ologramma] CTA clicked, starting playback')
          prompt.style.display = 'none'
          videoEl.play()
          el.setAttribute('visible', 'true')
          console.log('[ologramma] Entity visible, video playing')
        }
      })
    } else {
      console.warn('[play-video-correct] Autoplay disabled and CTA not found')
    }
  }
}

// custom-hold-drag component: allows dragging entity across ground plane with raycaster
const holdDragComponent = {
  schema: {
    cameraId: {default: 'camera'},
    groundId: {default: 'ground'},
    dragDelay: {default: 300},
    riseHeight: {default: 1},
  },
  init() {
    this.camera = document.getElementById(this.data.cameraId)
    this.threeCamera = this.camera?.getObject3D('camera')
    this.ground = document.getElementById(this.data.groundId)

    this.internalState = {
      fingerDown: false,
      dragging: false,
      distance: 0,
      startDragTimeout: null,
      raycaster: new THREE.Raycaster(),
      startPosition: new THREE.Vector3(),
    }

    this.fingerDown = this.fingerDown.bind(this)
    this.startDrag = this.startDrag.bind(this)
    this.fingerMove = this.fingerMove.bind(this)
    this.fingerUp = this.fingerUp.bind(this)

    this.el.addEventListener('mousedown', this.fingerDown)
    this.el.sceneEl.addEventListener('onefingermove', this.fingerMove)
    this.el.sceneEl.addEventListener('onefingerend', this.fingerUp)
    this.el.classList.add('cantap') // Needs "objects: .cantap" attribute on raycaster.
  },
  tick() {
    if (this.internalState.dragging) {
      let desiredPosition = null
      if (this.internalState.positionRaw) {
        const screenPositionX = (this.internalState.positionRaw.x / document.body.clientWidth) * 2 - 1
        const screenPositionY = (this.internalState.positionRaw.y / document.body.clientHeight) * 2 - 1
        const screenPosition = new THREE.Vector2(screenPositionX, -screenPositionY)

        this.threeCamera = this.threeCamera || this.camera.getObject3D('camera')

        this.internalState.raycaster.setFromCamera(screenPosition, this.threeCamera)
        const intersects = this.internalState.raycaster.intersectObject(this.ground.object3D, true)

        if (intersects.length > 0) {
          const intersect = intersects[0]
          this.internalState.distance = intersect.distance
          desiredPosition = intersect.point
        }
      }

      if (!desiredPosition) {
        desiredPosition = this.camera.object3D.localToWorld(new THREE.Vector3(0, 0, -this.internalState.distance))
      }

      desiredPosition.y = this.data.riseHeight
      this.el.object3D.position.lerp(desiredPosition, 0.2)
    }
  },
  remove() {
    this.el.removeEventListener('mousedown', this.fingerDown)
    this.el.sceneEl.removeEventListener('onefingermove', this.fingerMove)
    this.el.sceneEl.removeEventListener('onefingerend', this.fingerUp)
    if (this.internalState.fingerDown) {
      this.fingerUp()
    }
  },
  fingerDown(event) {
    this.internalState.startPosition = this.el.object3D.position.clone()
    this.internalState.fingerDown = true
    this.internalState.startDragTimeout = setTimeout(this.startDrag, this.data.dragDelay)
    this.internalState.positionRaw = event.detail.positionRaw
  },
  startDrag() {
    if (!this.internalState.fingerDown) {
      return
    }
    this.internalState.dragging = true
    this.internalState.distance = this.el.object3D.position.distanceTo(this.camera.object3D.position)
  },
  fingerMove(event) {
    this.internalState.positionRaw = event.detail.positionRaw
  },
  fingerUp() {
    this.internalState.fingerDown = false
    clearTimeout(this.internalState.startDragTimeout)

    this.internalState.positionRaw = null

    if (this.internalState.dragging) {
      const endPosition = this.el.object3D.position.clone()
      this.el.setAttribute('animation__drop', {
        property: 'position',
        to: `${endPosition.x} ${this.internalState.startPosition.y} ${endPosition.z}`,
        dur: 300,
        easing: 'easeOutQuad',
      })
    }
    this.internalState.dragging = false
  },
}

// look-at component: makes entity look at target, optionally without tilt
const lookAtComponent = {
  schema: {
    target: {type: 'string'},
    tilt: {default: false},
  },
  init() {
    if (!this.data.target) console.error('no target provided to look-at')
    this.target = document.querySelector(this.data.target)
  },
  tick() {
    if (!this.target) return
    this.targetPos = this.target.object3D.position.clone()
    if (!this.data.tilt) this.targetPos.setY(0)
    this.el.object3D.lookAt(this.targetPos)
  },
}

export { playVideoCorrectComponent, holdDragComponent, lookAtComponent } 